import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import $ from "jquery";
import Ebook from "../Ebook/Ebook";
import { useMediaQuery } from "react-responsive";
import NotesTabContainer from "./NotesTabContainer";
import CaseBriefContainer from "./CaseBriefContainer";
import { handleException } from "../../app/util/util";
import NoteBookListOutline from "../noteBookListOutline/NoteBookListOutline";
import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from "@syncfusion/ej2-react-navigations";
export function NoteBookContainer(props) {
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const lastReadPageNum = localStorage.getItem("lastPageReadNum");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-width: 1224px)" });
  const currentChapterId = props.bookVO ? props.bookVO.chapterId : undefined;
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const headerText = [
    { text: "eBook" },
    { text: "Outlines" },
    { text: "Case Briefs" },
    { text: "Notepad" },
    { text: "Questions" },
  ];
  const ebookTabContainer = (e) => {
    return (
      <Ebook
        userInfo={props.userInfo}
        bookVoPage={props.bookVoPage}
        bookInfo={props.bookInfo}
        bookVO={props.bookVO}
      />
    );
  };
  const outLineTabContainer = (e) => {
    return (
      <NoteBookListOutline
        bookVO={props.bookVO}
        userVO={props.userInfo}
        labelVOList={props.labelVOList}
        chapterId={props.bookVO.chapterId}
      />
    );
  };
  const caseBriefTabContainer = (e) => {
    return (
      <div className="mTopTen bookCont_rt">
        <CaseBriefContainer
          bookVO={props.bookVO}
          userVO={props.userInfo}
          labelVOList={props.labelVOList}
          chapterId={
            currentChapterId ? currentChapterId : props.bookVO.chapterId
          }
        ></CaseBriefContainer>
      </div>
    );
  };
  const notesTabContainer = (e) => {
    return (
      <NotesTabContainer
        bookVO={props.bookVO}
        userVO={props.userInfo}
        labelVOList={props.labelVOList}
      />
    );
  };
  const tabSelected = (e) => {
    let currentTab = e.selectedItem.textContent;
    if (currentTab !== "" && currentTab !== null && currentTab !== undefined) {
      currentTab = currentTab === "eBook" ? "eReader" : currentTab;
      let reqData = {
        userVO: {
          userId: userVO.userId,
          userRole: userVO.userRole,
          userRoleId: userVO.userRoleId,
          userActivityVO: {
            lastReadSectionId: "",
            lastReadParagraphId: "",
            lastViewedOutlineId: "",
            lastReadSubSectionId: "",
            pageNavigatingTo: "EReader",
            lastActivityCode: "BOOKSHELF",
            pageNavigatingFrom: "Bookshelf",
            lastReadBookId: props.bookVO.bookId,
            lastReadChapterId: currentChapterId,
          },
          sessionVO: {
            appType: "web",
            deviceMacId: "",
            keepMeLoggedInFlag: keepMeLogIn,
            deviceOS: localStorage.getItem("deviceOS"),
            deviceType: localStorage.getItem("deviceType"),
            browserName: localStorage.getItem("browserName"),
            sessionAuthenticationToken: userVO.sessionAuthenticationToken,
          },
        },
        userSettingsVO: [
          {
            userId: userVO.userId,
            bookId: props.bookVO.bookId,
            myNotebookType: currentTab,
          },
        ],
      };
      const requestOptions1 = {
        method: "POST",
        body: JSON.stringify(reqData),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      };
      fetch(
        `${localStorage.getItem("ENV")}/manageOutlineService/saveMyNotebook`,
        requestOptions1,
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "true") {
            const existingLocalSetsVO =
              JSON.parse(localStorage.getItem("userSettingsVO")) || {};
            if (existingLocalSetsVO)
              existingLocalSetsVO[0].myNotebookType = currentTab;
            localStorage.setItem(
              "userSettingsVO",
              JSON.stringify(existingLocalSetsVO),
            );
          } else if (data.wkErrorCode) {
            handleException(data);
          }
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error,
          );
        });
    }
  };
  const retainMyNoteBookTabs = (e) => {
    let tabObj = document.getElementById("defaultTab").ej2_instances[0];
    let tabMode = props.userSettingsVO[0].myNotebookType;
    if (
      tabMode !== "" &&
      tabMode !== undefined &&
      tabMode !== null &&
      tabObj !== "" &&
      tabObj !== undefined &&
      tabObj !== null
    ) {
      if (isDesktopOrLaptop) {
        if (props.bookVO.casesFlag === "true") {
          if (tabMode === "Outlines") {
            tabObj.select(0);
          } else if (tabMode === "Case Briefs") {
            tabObj.select(1);
          }
          if (tabMode === "Notepad") {
            tabObj.select(2);
          }
        } else {
          if (tabMode === "Outlines") {
            tabObj.select(0);
          }
          if (tabMode === "Notepad") {
            tabObj.select(1);
          }
        }
      } else {
        if (props.bookVO.casesFlag === "true") {
          if (tabMode === "eReader") {
            tabObj.select(0);
          } else if (tabMode === "Outlines") {
            tabObj.select(1);
          } else if (tabMode === "Case Briefs") {
            tabObj.select(2);
          }
          if (tabMode === "Notepad") {
            tabObj.select(3);
          }
        } else {
          if (tabMode === "eReader") {
            tabObj.select(0);
          } else if (tabMode === "Outlines") {
            tabObj.select(1);
          }
          if (tabMode === "Notepad") {
            tabObj.select(2);
          }
        }
      }
      setTimeout(function () {
        $(".Ereader").attr("tabIndex", -1);
        $(".Ereader").focus();
      }, 100);
    }
  };
  const tabSelect = (e) => {
    const selectedTabItem = e.selectingItem;
    if (selectedTabItem && selectedTabItem.innerText === "eBook") {
      const section = document.getElementById(
        `page-${lastReadPageNum ? lastReadPageNum : document.getElementById("pageNumTxt").value}`,
      );
      setTimeout(() => {
        if (section) {
          section.scrollIntoView();
          window.scroll(0, 0);
        }
      }, 1000);
    }
    if (e.isSwiped) {
      e.cancel = true;
    }
  };
  return (
    <TabComponent
      role="region"
      aria-label="My Notebook"
      className="mTopTen tabMainComponent"
      style={{ padding: "0 15px" }}
      heightAdjustMode="Auto"
      overflowMode="Scrollable"
      selected={tabSelected}
      selecting={tabSelect}
      created={retainMyNoteBookTabs}
      id="defaultTab"
    >
      <TabItemsDirective>
        {isTabletOrMobile && (
          <TabItemDirective
            header={headerText[0]}
            content={ebookTabContainer}
          />
        )}
        <TabItemDirective
          header={headerText[1]}
          content={outLineTabContainer}
        />
        {props.bookVO.casesFlag === "true" ? (
          <TabItemDirective
            header={headerText[2]}
            content={caseBriefTabContainer}
          />
        ) : null}
        <TabItemDirective header={headerText[3]} content={notesTabContainer} />
      </TabItemsDirective>
    </TabComponent>
  );
}
export default withRouter(NoteBookContainer);
